/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

let ATCMSClarityEvent = (productID,productIDArray,pageType,price,revenue,currency,quantity) => {
  return true;
  /*
  window.uetq = window.uetq || [];
  window.uetq.push('event', 'add_to_cart', { 
		'ecomm_prodid': productIDArray, 
		'ecomm_pagetype': pageType,
		'ecomm_totalvalue': revenue,
		'revenue_value': revenue,
		'currency': currency,
		'items': [{ 
		 'id': productID, 
		 'quantity': quantity, 
		 'price': price 
		 }] 
		}
	);
  */
}

document.addEventListener('DOMContentLoaded', function () {
    // Query the element
    const printBtn = document.getElementById('print_btn');
    if(null != printBtn) {
      printBtn.addEventListener('click', function () {
          // Create a fake iframe
          const iframe = document.createElement('iframe');
    
          // Make it hidden
          iframe.style.height = 0;
          iframe.style.visibility = 'hidden';
          iframe.style.width = 0;
    
          // Set the iframe's source
          iframe.setAttribute('srcdoc', '<html><body></body></html>');
    
          document.body.appendChild(iframe);
    
          iframe.contentWindow.addEventListener('afterprint', function () {
              iframe.parentNode.removeChild(iframe);
          });
    
          iframe.addEventListener('load', function () {
              // Clone the image
              const image = document.querySelector('#printableArea img').cloneNode();
              image.style.maxWidth = '100%';
    
              // Append the image to the iframe's body
              const body = iframe.contentDocument.body;
              body.style.textAlign = 'center';
              body.appendChild(image);
    
              image.addEventListener('load', function () {
                  // Invoke the print when the image is ready
                  iframe.contentWindow.print();
              });
          });
      });
    }
});

$(document).on('click','.Header__Wrapper',()=>{
  if(typeof window.clarity !== 'undefined') {
    window.clarity("event", "navbarClick")
  }
});

document.addEventListener('product:added', function(event) {
  /*
    console.log("68");
    console.log(event);
  */
  let variant = event.detail.variant; // Get the variant that was added
  let quantity = event.detail.quantity; // Get the quantity that was added
  /*
    var variant = event.detail.variant; // Get the variant that was added
    var quantity = event.detail.quantity; // Get the quantity that was added
  */

});

// -----------  js Added for complete the look section in product page start here 

 $('.product-info .HorizontalList__Item input[type=radio]').change(function(){
            
        let demoats = [];
        let myVar2 = [];      
    
        var dere = $(this).parents('.product-info').find('.product-variant-info .HorizontalList');        
        $.each( dere, function( key, value ) {
        var srp_var = $(this).find(".HorizontalList__Item input[type='radio']:checked").val();
       
        demoats.push(srp_var);        
        myVar2 = demoats.join(' / ');        
        })
       var prets = $(this).parents('.product-info').find('.product-variant-selector option');    
         $.each( prets, function( key, value ) {                 
            var d_option = $(this).data('attr');                               
            if( d_option == myVar2 ){
            var demnstar = $(this).attr('value');               
              $(this).attr('selected', true).siblings().attr('selected', false); 
               var on_select_price = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-price');
               $(this).parents('.product-info').find('.price_tag').html(on_select_price);
              var on_select_quantity = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-quantity');              
              if(on_select_quantity <= 0)
              {
                $(this).parents('.product-info').find('.add_to_cart_btn').attr('disabled', 'disabled');
                $(this).parents('.product-info').find('.add_to_cart_btn').removeClass('Button--primary');
                $(this).parents('.product-info').find('.add_to_cart_btn').addClass('Button--secondary');
                $(this).parents('.product-info').find('.add_to_cart_btn').text('SOLD OUT');                
              }
              else{
                 $(this).parents('.product-info').find('.add_to_cart_btn').removeAttr('disabled', 'disabled');
                $(this).parents('.product-info').find('.add_to_cart_btn').addClass('Button--primary');
                $(this).parents('.product-info').find('.add_to_cart_btn').removeClass('Button--secondary');
                $(this).parents('.product-info').find('.add_to_cart_btn').text('ADD TO CART');      
              }
              var on_select_var_img = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-variant-image');
              $(this).parents('.product-info').find('.img-info img').attr('src',on_select_var_img);
                               
            }        
        }) 
     
      })
      let data = '';
  $(document).on('click','.product-info .add_to_cart_btn',function(){  
    
   var btn_this = this;    
        let demoats = [];
        let myVar2 = [];          
        var dere = $(this).parents('.product-info').find('.product-variant-info .HorizontalList');        
        $.each( dere, function( key, value ) {
        var srp_var = $(this).find(".HorizontalList__Item input[type='radio']:checked").val();       
        demoats.push(srp_var);       
        myVar2 = demoats.join(' / ');             
        })
        var prets = $(this).parents('.product-info').find('.product-variant-selector option');    
         $.each( prets, function( key, value ) {                 
            var d_option = $(this).data('attr');                                   
            if( d_option == myVar2 ){
            var demnstar = $(this).attr('value');             
              $(this).attr('selected', true).siblings().attr('selected', false);                                                      
            }        
        })  
    
var ID = $(this).parents('.product-info').find('.product-variant-selector').find(":selected").val();  
let properties = $('#giftNote').val();
console.log(typeof properties)
if(properties != ''){
  data = {
    quantity: 1,
    id: ID,
    properties: { 'Gift Note' : properties }
  }
}else{
  data = {
    quantity: 1,
    id: ID,
  }
}

$.ajax({
type: 'POST',
url: '/cart/add.js',
data: data,
  dataType: 'json', 
 success: function (responseData) {
    $(this).removeAttr('disabled');    
    document.dispatchEvent(new CustomEvent('product:added', {
           bubbles: true,
           detail: {
                variant: null,
                quantity: 1
              }
            }));
            // $('.ProductForm input[name="properties[Gift Note]"]').remove();
            $('#giftNote').val('');
 },
      error: function (error) { 
         var error_html = '<div class="error_msg"></div>'
         $( ".add_to_cart_btn" ).after(error_html); 
         var error_msg_show = error.responseJSON.description;     
         $(btn_this).parents('.product-info').find('.error_msg').html(error_msg_show);                
         setTimeout(function () {
                $(".error_msg").remove();
         }, 2500);
      }
 });
})


// -----------  js Added for complete the look section in product page end here 

//**********************************

// -----------  js Added for Related product in product page start here 


 $('.rp-pro-block .HorizontalList__Item input[type=radio]').change(function(){
            
        let demoats = [];
        let myVar2 = [];      
    
        var dere = $(this).parents('.rp-pro-block').find('.product-variant-info .HorizontalList');        
        $.each( dere, function( key, value ) {
        var srp_var = $(this).find(".HorizontalList__Item input[type='radio']:checked").val();
       
        demoats.push(srp_var);        
        myVar2 = demoats.join(' / ');        
        })
       var prets = $(this).parents('.rp-pro-block').find('.product-variant-selector option');    
         $.each( prets, function( key, value ) {                 
            var d_option = $(this).data('attr');                               
            if( d_option == myVar2 ){
            var demnstar = $(this).attr('value');               
              $(this).attr('selected', true).siblings().attr('selected', false); 
               var on_select_price = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-price');
               $(this).parents('.rp-pro-block').find('.ProductItem__Price.Price--highlight').html(on_select_price);
               var on_select_compare_price = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-compare-price');
               $(this).parents('.rp-pro-block').find('.ProductItem__Price.Price--compareAt').html(on_select_compare_price);
              var on_select_quantity = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-quantity');              
              if(on_select_quantity <= 0)
              {
                $(this).parents('.rp-pro-block').find('.add_to_cart_btn').attr('disabled', 'disabled');
                // $(this).parents('.rp-pro-block').find('.add_to_cart_btn').removeClass('Button--primary');
                // $(this).parents('.rp-pro-block').find('.add_to_cart_btn').addClass('Button--secondary');
                $(this).parents('.rp-pro-block').find('.add_to_cart_btn').text('SOLD OUT');                
              }
              else{
                 $(this).parents('.rp-pro-block').find('.add_to_cart_btn').removeAttr('disabled', 'disabled');
                // $(this).parents('.rp-pro-block').find('.add_to_cart_btn').addClass('Button--primary');
                // $(this).parents('.rp-pro-block').find('.add_to_cart_btn').removeClass('Button--secondary');
                $(this).parents('.rp-pro-block').find('.add_to_cart_btn').text('ADD TO CART');      
              }
              var on_select_var_img = $(this).parents('.product-variant-info').find('.product-variant-selector :selected').attr('data-variant-image');              
              $(this).parents('.rp-pro-block').find('img.related_pro_first_img').attr('srcset',on_select_var_img);
                               
            }        
        }) 
     
      })

  $(document).on('click','.rp-pro-block .add_to_cart_btn',function(){      
   var btn_this = this;    
        let demoats = [];
        let myVar2 = [];          
        var dere = $(this).parents('.rp-pro-block').find('.product-variant-info .HorizontalList');        
        $.each( dere, function( key, value ) {
        var srp_var = $(this).find(".HorizontalList__Item input[type='radio']:checked").val();       
        demoats.push(srp_var);       
        myVar2 = demoats.join(' / ');             
        })  
        var prets = $(this).parents('.rp-pro-block').find('.product-variant-selector option');    
         $.each( prets, function( key, value ) {                 
            var d_option = $(this).data('attr');                                   
            if( d_option == myVar2 ){
            var demnstar = $(this).attr('value');             
              $(this).attr('selected', true).siblings().attr('selected', false);                                                      
            }        
        })  
    
var ID = $(this).parents('.rp-pro-block').find('.product-variant-selector').find(":selected").val(); 
    // console.log(ID);
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
  quantity: 1,
  id: ID
},
  dataType: 'json', 
 success: function (data) {    
     $(this).removeAttr('disabled');    
   document.dispatchEvent(new CustomEvent('product:added', {
           bubbles: true,
           detail: {
                variant: null,
                quantity: 1
              }
            }));
 },
      error: function (error) { 
         var error_html = '<div class="error_msg"></div>'
        // var add_btn = $(btn_this).parents('.rp-pro-block').find( ".add_to_cart_btn" );
         // $(add_btn).after(error_html); 

        $(btn_this).after(error_html); 
         var error_msg_show = error.responseJSON.description;     
         $(btn_this).parents('.rp-pro-block').find('.error_msg').html(error_msg_show);                
         setTimeout(function () {
                $(".error_msg").remove();
         }, 2500);
      }
 });
})

$(".related-pro-scroll").click(function() {
    $('html, body').animate({
        scrollTop: $("#related-product-section-scroll").offset().top-70
    }, 800); 
});
// -----------  js Added for Related product in product page end here 

$(document).ready(function(){
  $(document).on('change','.ColorSwatch__Radio,.SizeSwatch__Radio',function(){
    // $('.ProductForm input[name="properties[Gift Note]"]').remove();
        $('#giftNote').val('');

        // $("html, body").animate({ scrollTop: 0 });

        let preOrderElement = $('p[title="pre-order-text"]');
        $('.ProductForm__Option select.product-form-select option[selected="selected"]').each(function() {
          let preOrderText = $(this).attr('data-pre-order-text');
          if (preOrderText) {
            preOrderElement.text(preOrderText);
            $('.ProductForm__AddToCart span').text('PRE ORDER');
          } else {
            preOrderElement.text('');
            $('.ProductForm__AddToCart span').text('ADD TO BAG');
          }
      });
  })
})


$(document).ready(function(){
  $(".accordian-slider-column").mouseenter(function(){
    $('.accordian-slider-column').removeClass('active');
    $(this).addClass('active');
});
$(".mobile-slider-image-wrapper").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  draggable: true,
  adaptiveHeight: false,
  autoplay:true,
  prevArrow: '<button type="button" class="prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4082 20C15.33 20 15.2525 19.9832 15.1806 19.9506C15.1087 19.918 15.0438 19.8703 14.9898 19.8105L8.2947 12.7445C8.20132 12.6466 8.1272 12.5301 8.07662 12.4018C8.02604 12.2735 8 12.1358 8 11.9968C8 11.8578 8.02604 11.7202 8.07662 11.5918C8.1272 11.4635 8.20132 11.3471 8.2947 11.2492L14.9898 4.1832C15.0447 4.12512 15.11 4.07905 15.1818 4.04761C15.2536 4.01618 15.3305 4 15.4082 4C15.4859 4 15.5629 4.01618 15.6347 4.04761C15.7065 4.07905 15.7717 4.12512 15.8267 4.1832C15.8816 4.24128 15.9252 4.31023 15.955 4.38612C15.9847 4.46201 16 4.54334 16 4.62548C16 4.70762 15.9847 4.78895 15.955 4.86484C15.9252 4.94073 15.8816 5.00968 15.8267 5.06776L9.28103 11.9968L15.8267 18.9259C15.9023 19.015 15.9524 19.1249 15.9711 19.2429C15.9899 19.3609 15.9766 19.4821 15.9328 19.5924C15.889 19.7027 15.8164 19.7976 15.7235 19.866C15.6307 19.9345 15.5213 19.9736 15.4082 19.9789V20Z" fill="currentColor"></path></svg></button>',
  nextArrow: '<button type="button" class="next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.59175 20C8.47866 19.9947 8.36933 19.9555 8.27647 19.8871C8.18361 19.8187 8.11104 19.7238 8.06721 19.6135C8.02338 19.5031 8.01008 19.3819 8.02886 19.2639C8.04765 19.146 8.09774 19.036 8.17332 18.9469L14.7188 12.0179L8.17332 5.06776C8.06235 4.95046 8 4.79137 8 4.62548C8 4.45959 8.06235 4.3005 8.17332 4.1832C8.28429 4.0659 8.43481 4 8.59175 4C8.74869 4 8.89921 4.0659 9.01018 4.1832L15.7051 11.2492C15.7985 11.3471 15.8726 11.4635 15.9231 11.5918C15.9737 11.7202 15.9998 11.8578 15.9998 11.9968C15.9998 12.1358 15.9737 12.2735 15.9231 12.4018C15.8726 12.5301 15.7985 12.6466 15.7051 12.7445L9.01018 19.8105C8.95621 19.8703 8.8913 19.918 8.81937 19.9506C8.74744 19.9832 8.67 20 8.59175 20Z" fill="currentColor"></path></svg></button>',
  responsive: [
      {
          breakpoint: 992,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false,
          },
      },
      {
          breakpoint: 768,
          settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false,
          }
      }
  ]
});
  $(".image-with-text .image-with-text-wrapper").slick({
    infinite: false,
    slidesToShow: 5.4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    draggable: true,
    adaptiveHeight: false,
    prevArrow: '<button type="button" class="prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4082 20C15.33 20 15.2525 19.9832 15.1806 19.9506C15.1087 19.918 15.0438 19.8703 14.9898 19.8105L8.2947 12.7445C8.20132 12.6466 8.1272 12.5301 8.07662 12.4018C8.02604 12.2735 8 12.1358 8 11.9968C8 11.8578 8.02604 11.7202 8.07662 11.5918C8.1272 11.4635 8.20132 11.3471 8.2947 11.2492L14.9898 4.1832C15.0447 4.12512 15.11 4.07905 15.1818 4.04761C15.2536 4.01618 15.3305 4 15.4082 4C15.4859 4 15.5629 4.01618 15.6347 4.04761C15.7065 4.07905 15.7717 4.12512 15.8267 4.1832C15.8816 4.24128 15.9252 4.31023 15.955 4.38612C15.9847 4.46201 16 4.54334 16 4.62548C16 4.70762 15.9847 4.78895 15.955 4.86484C15.9252 4.94073 15.8816 5.00968 15.8267 5.06776L9.28103 11.9968L15.8267 18.9259C15.9023 19.015 15.9524 19.1249 15.9711 19.2429C15.9899 19.3609 15.9766 19.4821 15.9328 19.5924C15.889 19.7027 15.8164 19.7976 15.7235 19.866C15.6307 19.9345 15.5213 19.9736 15.4082 19.9789V20Z" fill="currentColor"></path></svg></button>',
    nextArrow: '<button type="button" class="next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.59175 20C8.47866 19.9947 8.36933 19.9555 8.27647 19.8871C8.18361 19.8187 8.11104 19.7238 8.06721 19.6135C8.02338 19.5031 8.01008 19.3819 8.02886 19.2639C8.04765 19.146 8.09774 19.036 8.17332 18.9469L14.7188 12.0179L8.17332 5.06776C8.06235 4.95046 8 4.79137 8 4.62548C8 4.45959 8.06235 4.3005 8.17332 4.1832C8.28429 4.0659 8.43481 4 8.59175 4C8.74869 4 8.89921 4.0659 9.01018 4.1832L15.7051 11.2492C15.7985 11.3471 15.8726 11.4635 15.9231 11.5918C15.9737 11.7202 15.9998 11.8578 15.9998 11.9968C15.9998 12.1358 15.9737 12.2735 15.9231 12.4018C15.8726 12.5301 15.7985 12.6466 15.7051 12.7445L9.01018 19.8105C8.95621 19.8703 8.8913 19.918 8.81937 19.9506C8.74744 19.9832 8.67 20 8.59175 20Z" fill="currentColor"></path></svg></button>',
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3.2,
                slidesToScroll: 1,
                arrows:false,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2.2,
                slidesToScroll: 1,
                arrows:false,
            }
        }
    ]
  });
  $(".featured-collection-right-wrapper .featured-collection-column-wrapper").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    centerMode: false,
    centerPadding: '0px',
    prevArrow: '<button type="button" class="prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.4082 20C15.33 20 15.2525 19.9832 15.1806 19.9506C15.1087 19.918 15.0438 19.8703 14.9898 19.8105L8.2947 12.7445C8.20132 12.6466 8.1272 12.5301 8.07662 12.4018C8.02604 12.2735 8 12.1358 8 11.9968C8 11.8578 8.02604 11.7202 8.07662 11.5918C8.1272 11.4635 8.20132 11.3471 8.2947 11.2492L14.9898 4.1832C15.0447 4.12512 15.11 4.07905 15.1818 4.04761C15.2536 4.01618 15.3305 4 15.4082 4C15.4859 4 15.5629 4.01618 15.6347 4.04761C15.7065 4.07905 15.7717 4.12512 15.8267 4.1832C15.8816 4.24128 15.9252 4.31023 15.955 4.38612C15.9847 4.46201 16 4.54334 16 4.62548C16 4.70762 15.9847 4.78895 15.955 4.86484C15.9252 4.94073 15.8816 5.00968 15.8267 5.06776L9.28103 11.9968L15.8267 18.9259C15.9023 19.015 15.9524 19.1249 15.9711 19.2429C15.9899 19.3609 15.9766 19.4821 15.9328 19.5924C15.889 19.7027 15.8164 19.7976 15.7235 19.866C15.6307 19.9345 15.5213 19.9736 15.4082 19.9789V20Z" fill="currentColor"></path></svg></button>',
    nextArrow: '<button type="button" class="next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.59175 20C8.47866 19.9947 8.36933 19.9555 8.27647 19.8871C8.18361 19.8187 8.11104 19.7238 8.06721 19.6135C8.02338 19.5031 8.01008 19.3819 8.02886 19.2639C8.04765 19.146 8.09774 19.036 8.17332 18.9469L14.7188 12.0179L8.17332 5.06776C8.06235 4.95046 8 4.79137 8 4.62548C8 4.45959 8.06235 4.3005 8.17332 4.1832C8.28429 4.0659 8.43481 4 8.59175 4C8.74869 4 8.89921 4.0659 9.01018 4.1832L15.7051 11.2492C15.7985 11.3471 15.8726 11.4635 15.9231 11.5918C15.9737 11.7202 15.9998 11.8578 15.9998 11.9968C15.9998 12.1358 15.9737 12.2735 15.9231 12.4018C15.8726 12.5301 15.7985 12.6466 15.7051 12.7445L9.01018 19.8105C8.95621 19.8703 8.8913 19.918 8.81937 19.9506C8.74744 19.9832 8.67 20 8.59175 20Z" fill="currentColor"></path></svg></button>',
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows:false,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:false,
              centerMode: true,
              centerPadding: '70px',
            }
        }
    ]
  });


    if($('.ProductList .ProductItem').length > 0 ){
    $('.ProductList .ProductItem').matchHeight({
      byRow: true,
      });
    }

  setTimeout(function(){
    if($('.ProductRecommendations .ProductList .ProductItem').length > 0 ){
    $('.ProductRecommendations .ProductList .ProductItem').matchHeight({
      byRow: true,
      });
    }
  },2000)
  

  if($('.custom-ar-recommendation-section .ProductList .ProductItem').length > 0 ){
    $('.custom-ar-recommendation-section .ProductList .ProductItem').matchHeight({
      byRow: true,
    });
  }
  $(document).on( 'load resize', function(){
    $('.custom-ar-recommendation-section .ProductList .ProductItem').matchHeight({
      byRow: true,
    });
  })
  
});


var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 10);
  }
};

waitForEl('.klaviyo-custom-form .klaviyo-form .needsclick', function() {
  $('.blackfriday-landing-page .klaviyo-custom-form').find('.loader_circle_1').remove()
  $('.blackfriday-landing-page .klaviyo-custom-form').css('height','auto'); 
  $('.blackfriday-landing-page .klaviyo-custom-form.loader-element').removeClass('loader-element')
});



// Function to set --header-height and --cate-nav-height CSS variables
function setHeight() {
  console.log("setHeight run");

  const header = document.querySelector('.Header');
  const cateNav = document.querySelector('.collection__category-nav-parent');

  let headerHeight = header?.offsetHeight || 0;  
  let cateNavHeight = cateNav?.offsetHeight || 0;


  // Set the CSS variables on <html> (documentElement)
  document.documentElement.style.setProperty('--head-height', `${headerHeight}px`);
  document.documentElement.style.setProperty('--cate-nav-height', `${cateNavHeight}px`);
}

// Initialize on DOMContentLoaded and resize
document.addEventListener('DOMContentLoaded', setHeight);
window.addEventListener('resize', setHeight);

// Update on scroll as well
let prevHeaderHeight = 0;

function checkHeightChange() {
  const header = document.querySelector('.Header');
  const currentHeaderHeight = header ? header.offsetHeight : 0;

  // Only update if header height has changed
  if (currentHeaderHeight !== prevHeaderHeight) {
    setHeight();
    prevHeaderHeight = currentHeaderHeight;
  }
}

// Throttle scroll event to avoid performance issues
window.addEventListener('scroll', () => {
  requestAnimationFrame(checkHeightChange);
});

const paymentTermsElement = document.querySelector('shopify-payment-terms');
const shadowRoot = paymentTermsElement?.shadowRoot || paymentTermsElement?.attachShadow({ mode: 'open' });
const style = document.createElement('style');
style.textContent = `
  #shopify-installments {
     display:none;
  }
`;
shadowRoot?.appendChild(style); 






/**
* jquery-match-height master by @liabru
* http://brm.io/jquery-match-height/
* License: MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,a=function(t){return parseFloat(t)||0},n=function(e){var o=t(e),n=null,i=[];return o.each(function(){var e=t(this),o=e.offset().top-a(e.css("margin-top")),r=i.length>0?i[i.length-1]:null;null===r?i.push(e):Math.floor(Math.abs(n-o))<=1?i[i.length-1]=r.add(e):i.push(e),n=o}),i},i=function(e){var o={byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var a=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(a)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="master",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,r._afterUpdate=null,r._rows=n,r._parse=a,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0","padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=n(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var n=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&n.length<=1)return void n.css(s.property,"");n.each(function(){var e=t(this),o=e.attr("style"),a=e.css("display");"inline-block"!==a&&"flex"!==a&&"inline-flex"!==a&&(a="block");var n={display:a};n[s.property]="",e.css(n),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}n.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=a(e.css("border-top-width"))+a(e.css("border-bottom-width")),o+=a(e.css("padding-top"))+a(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),a=o.attr("data-mh")||o.attr("data-match-height");e[a]=a in e?e[a].add(o):o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(a,n){if(n&&"resize"===n.type){var i=t(window).width();if(i===e)return;e=i}a?-1===o&&(o=setTimeout(function(){s(n),o=-1},r._throttle)):s(n)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});


$('.shopTheLook__similar .shopTheLook__descWrapper p').matchHeight({
  byRow: 0,
});